import { useMemo } from 'react';

import { useIsInstagramIOSWebview } from '#src/app/shared/hooks/userAgent';

import type { ShareLink } from './types';

/**
 * Removes channels that the current in-app browser can never open. Instagram's iOS in-app browser does
 * not hand `fb-messenger://` to iOS, so Messenger never opens from it, even from a direct tap on a plain
 * link. Other webviews (Facebook, Gmail, Android) open it. The check reads the user agent, so the
 * server render already leaves the button out and nothing flickers.
 */
export function useInAppBrowserFilteredLinks<L extends Pick<ShareLink, 'channel'>>(links: readonly L[]): readonly L[] {
	const isInstagramIOS = useIsInstagramIOSWebview();

	return useMemo(
		() => (isInstagramIOS ? links.filter((link) => link.channel !== 'facebookMessenger') : links),
		[links, isInstagramIOS],
	);
}
